<script setup lang="ts">
import { TrackerEvents } from "~/enums/tracking/tracker.enums";

const { dispatchTrackingEvent } = useTracking();
const courseTracking = useTrackingCourse();
const { course, getActivity } = useCourseState();
const route = useRoute();
const { t } = useI18n();

defineProps<{
  withFrame?: Boolean;
}>();

const courseResources = computed(() => {
  return course.value?.learningResources || [];
});

const activityResources = computed(() => {
  // only lessons have resources
  if (route.params.lessonId === undefined) {
    return [];
  }

  const activity = getActivity(route.params.lessonId as string);

  return activity?.learningResourceDownloads || [];
});

onMounted(() => {
  dispatchTrackingEvent(TrackerEvents.CourseResourcesView);
});
</script>

<template>
  <div class="px-4 py-6">
    <div
      v-if="activityResources?.length"
      class="mb-6"
    >
      <div class="text-neutral-60 uppercase font-bold text-12 mb-2">
        {{t('course.sidebar.tabs.resources.lessonResources.title')}}
      </div>

      <div
        v-if="course"
        class="flex flex-col gap-2"
      >
        <CourseSidebarTabsResourcesItem
          v-for="resource in activityResources"
          :key="resource.uuid"
          :course="course"
          :resource="resource"
        />
      </div>
    </div>

    <div v-if="courseResources?.length">
      <div class="text-neutral-60 uppercase font-bold text-12 mb-2">
        <!-- todo: should this be also differentiated to course/workshop (currently it'd always say "course resources", even for workshops) -->
        {{t('course.sidebar.tabs.resources.lessonResources.title')}}
      </div>

      <div
        v-if="course"
        class="flex flex-col gap-2"
      >
        <CourseSidebarTabsResourcesItem
          v-for="resource in courseResources"
          :key="resource.uuid"
          :course="course"
          :resource="resource"
          @downloaded="(resource) => courseTracking.resourceDownloaded(course, resource)"
        />
      </div>
    </div>
  </div>
</template>
